import { Injectable } from '@angular/core';

// SERVICES
import { Observable } from 'rxjs';

import { EnvironmentUtilService } from '../../util';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class TrackstarApiService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  getLinkToken() :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/trackstar/get-link-token`,
      body: {},
    });
  }

  getAccessToken(payload :{ auth_code :string }) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/trackstar/get-access-token`,
      body: payload,
    });
  }

  getTrackstarEnvironment() :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/trackstar/get-environment`,
    );
  }
}
